export default __webpack_public_path__ + "static/media/211.08df4524.png";